import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import './styles/globals.css';

// Import pages
import Home from './pages/Home';
import Methodology from './pages/Methodology';

// Import components
import Navbar from './components/Navbar';
import { DataProvider } from './context/DataContext';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa; /* Match the HomeContainer background color */
`;

function App() {
  return (
    <DataProvider>
      <AppContainer>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/methodology" element={<Methodology />} />
        </Routes>
      </AppContainer>
    </DataProvider>
  );
}

export default App; 